// extracted by mini-css-extract-plugin
export default {"profileTitleContainer":"ProfileTitle_profileTitleContainer__mSVlB"};